const tagsDefaultState = {
  tags: [],
  isLoading: false,
  isReady: false
};

export default (state=tagsDefaultState, action) => {
  switch (action.type) {
    case 'SET_TAGS' :
      return {
        ...state,
        tags: action.tags,
        isReady: true,
        isLoading: false
      };
    case 'SET_TAGS_LOADING' :
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};
